module.exports = __webpack_public_path__ + "resource/img/image021.a555e227.png";